const trendsIT = {
    "view": {
        "form": {
            "label": {
                "filters": "Filtri",
                "period": "Periodo",
                "store": "Negozio",
                "label": "Etichetta",
                "release": "Pubblicazione",
                "track": "Traccia",
                "subuser": "Sotto-utente",
                "fetchingTrends": "Recupero delle tendenze dal database"
            },
            "button": {
                "resetFilters": "Reimposta filtri"
            },
            "options": {
                "store": {
                    "allStores": "Tutti i negozi",
                    "downloadStores": "Negozi di download",
                    "streamingStores": "Negozi di streaming",
                    "streamStores": "Negozi di stream"
                },
                "label": {
                    "allLabels": "Tutte le etichette"
                },
                "release": {
                    "allReleases": "Tutte le pubblicazioni"
                },
                "track": {
                    "allTracks": "Tutte le tracce"
                },
                "subuser": {
                    "selectSubuser": "Seleziona sotto-utente"
                },
                "period": {
                    "last7Days": "Ultimi 7 giorni",
                    "last14Days": "Ultimi 14 giorni",
                    "last30Days": "Ultimi 30 giorni",
                    "last45Days": "Ultimi 45 giorni",
                    "last60Days": "Ultimi 60 giorni",
                    "last75Days": "Ultimi 75 giorni",
                    "last90Days": "Ultimi 90 giorni"
                }
            }
        },
        "top10": {
            "title": "Top 10",
            "table": {
                "column": {
                    "artistName": "Artista",
                    "songMixName": "Nome Canzone/Mix",
                    "numberOfSales": "Numero di Vendite"
                }
            }
        },
        "storeWiseSales": {
            "title": "Vendite per Negozio",
            "label": {
                "amazonMusicStream": "Amazon Music stream",
                "appleMusicStream": "Apple Music stream",
                "beatportStream": "Beatport stream",
                "deezerStream": "Deezer stream",
                "facebookStream": "Facebook stream",
                "instagramStream": "Instagram stream",
                "itunesDownload": "iTunes download",
                "pandoraStream": "Pandora stream",
                "soundcloudStream": "SoundCloud stream",
                "spotifyStream": "Spotify stream",
                "tiktokStream": "Tiktok stream",
                "traxsourceStream": "Traxsource stream",
                "youtubeStream": "Youtube stream",
                "youtubePremiumStream": "Youtube Premium stream",
                "totalSales": "Vendite totali",
                "storeMessage": "* Le etichette dei negozi sono ordinate alfabeticamente (A-Z)"
            }
        },
        "salesByTerritory": {
            "title": "Vendite per Territorio"
        },
        "salesByGender": {
            "title": "Vendite per Genere",
            "label": {
                "male": "Maschio",
                "female": "Femmina",
                "nonBinary": "Non-binario",
                "unknown": "Sconosciuto"
            }
        },
        "salesByAge": {
            "title": "Vendite per Età",
            "label": {
                "male": "Maschio",
                "female": "Femmina",
                "genderOther": "Non-binario",
                "unknown": "Sconosciuto",
                "ageWiseSales": "Vendite per Età",
                "ageUnknown": "Età Sconosciuta"
            }
        },
        "message": {
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Per favore <1>riprendi</1> il tuo abbonamento per usufruire di questa funzione.",
            "subscriptionUpgrade": "Il tuo attuale piano di abbonamento non supporta questa funzione. Per favore <1>aggiorna</1> il tuo piano di abbonamento per usufruire di questa funzione."
        }
    }
};

export default trendsIT;